// Fail closed if the CMP is blocked: an optional popup must not race consent UI.
export function scheduleConsentPopup({ open, close, delay, win = window, doc = document }) {
   let interacted = false;
   let shown = false;
   let timer = null;
   let idle = null;
   const observed = new WeakSet();
   const events = ['pointerdown', 'keydown', 'scroll', 'touchstart'];
   const consentEvents = ['CookiebotOnConsentReady', 'CookiebotOnAccept', 'CookiebotOnDecline', 'CookiebotOnDialogHide'];
   try { shown = win.sessionStorage.getItem('popupShown') === 'true'; } catch (_) { /* Storage may be unavailable. */ }

   const ready = () => {
      const cmp = win.Cookiebot;
      const dialog = doc.getElementById('CybotCookiebotDialog');
      const widget = doc.getElementById('CookiebotWidget');
      const dialogVisible = dialog && dialog.getClientRects().length > 0
         && win.getComputedStyle(dialog).visibility !== 'hidden';
      return cmp && cmp.hasResponse && !dialogVisible
         && !widget?.classList.contains('CookiebotWidget-open')
         && doc.visibilityState === 'visible';
   };
   const cancel = () => {
      win.clearTimeout(timer);
      if (idle !== null && win.cancelIdleCallback) win.cancelIdleCallback(idle);
      timer = null;
      idle = null;
   };
   const reveal = () => {
      idle = null;
      if (shown || !ready()) return;
      shown = true;
      open();
      try { win.sessionStorage.setItem('popupShown', 'true'); } catch (_) { /* Keep in-memory state. */ }
      events.forEach((name) => win.removeEventListener(name, interact));
   };
   const schedule = () => {
      if (shown || !interacted || timer !== null || idle !== null || !ready()) return;
      timer = win.setTimeout(() => {
         timer = null;
         if (!ready()) return;
         if (win.requestIdleCallback) idle = win.requestIdleCallback(reveal, { timeout: 2500 });
         else reveal();
      }, delay);
   };
   const interact = () => { interacted = true; schedule(); };
   const pause = () => { cancel(); close(); };
   const observeConsentUI = () => {
      if (!win.MutationObserver) return;
      ['CybotCookiebotDialog', 'CookiebotWidget'].forEach((id) => {
         const element = doc.getElementById(id);
         if (!element || observed.has(element)) return;
         observed.add(element);
         new win.MutationObserver(() => {
            if (!ready()) pause();
            else schedule();
         }).observe(element, { attributes: true, attributeFilter: ['style', 'class', 'aria-hidden'] });
      });
   };
   const consentChanged = () => { observeConsentUI(); cancel(); schedule(); };

   events.forEach((name) => win.addEventListener(name, interact, { passive: true }));
   consentEvents.forEach((name) => win.addEventListener(name, consentChanged));
   win.addEventListener('CookiebotOnDialogDisplay', () => { observeConsentUI(); pause(); });
   doc.addEventListener('visibilitychange', consentChanged);
   // Widget opening/closing is not covered by the banner's public events.
   doc.addEventListener('click', (event) => {
      if (!event.target.closest?.('#CookiebotWidget')) return;
      pause();
      win.setTimeout(schedule, 0);
   });
   observeConsentUI();
}
